module.exports = __webpack_public_path__ + "static/admin-17c97427b2e8b3dfb2c03101b7ab306e.jpg";